import { UserData } from '@dap/admin/types';

export const hasUserOmniumLeadsAccess = (userData: UserData) =>
  userData.apps.some((app) => app.key === 'omnium') &&
  (userData.metadata.superuser ||
    userData.roles.some(({ role }) => role.key === 'kjedeadmin' || role.key === 'prosjektsalg'));
